import { useMemo } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { IGroup } from '../../types/group'
import { getParams } from '../../services/search'
import { ICrumbItem } from './Crumb'

export const useCrumbs = ({ name, shortTitle }: IGroup) => {
  const { packId } = useParams()
  const { pathname, search } = useLocation()

  const isSearchPage = useMemo(() => pathname.endsWith('search'), [pathname])
  const { group: groupIdFromSearch } = useMemo(() => getParams(search), [
    search,
  ])

  const groupId = name || groupIdFromSearch
  const groupHomeCrumb: ICrumbItem = useMemo(
    () => ({
      text: 'Graphics',
      accentedText: 'Portal',
      linkTo: groupId && groupId !== 'all' ? `/group/${groupId}` : '/',
      theme: 'portal',
      autoClassName: 'auto-portal-crumb',
    }),
    [groupId]
  )

  const groupPublishCrumb: ICrumbItem = useMemo(
    () => ({
      text: shortTitle,
      accentedText: 'Group',
      linkTo: `/group/${groupId}/publish`,
      theme: 'group',
      autoClassName: 'auto-group-crumb',
    }),
    [groupId, shortTitle]
  )

  return [groupHomeCrumb, (packId || isSearchPage) && groupPublishCrumb].filter(
    Boolean
  ) as ICrumbItem[]
}
